import { createSlice } from "@reduxjs/toolkit";

const accountDetailSlice = createSlice({
  name: "accountDetail",
  initialState: {
    details: {
      employee_id: 1,
      first_name: "first_name",
      last_name: "last_name",
      department: "department",
      employment_start_date: null,
      employment_end_date: null,
      is_active: true,
      account_type: "account_type",
      position_id: [],
      positions: [],
    },
    latest_cos: [],
    latest_trl: [],
    latest_cwa: [],
    account_types: [],
  },
  reducers: {
    setEmployeeDetail(state, action) {
      state.details = action.payload;
    },
    setAccountTypes(state, action) {
      state.account_types = action.payload;
    },
    setLatestCos(state, action) {
      state.latest_cos = action.payload;
    },
    setLatestTrl(state, action) {
      state.latest_trl = action.payload;
    },
    setLatestCwa(state, action) {
      state.latest_cwa = action.payload;
    },
  },
  devTools: true,
});

export const {
  setEmployeeDetail,
  setAccountTypes,
  setLatestCos,
  setLatestTrl,
  setLatestCwa,
} = accountDetailSlice.actions;

export default accountDetailSlice.reducer;
